import properties from '../../constants/Properties';
import storeManager from '../../store/StoreManager';
import createShapes from './CreateShapes';
import { changeCartoonistTabIndex, changeContextMode } from '../../actions/MenuActions';
import modeType from '../../constants/ModeConstants';
import { changeShapesPosition, insertImageNode, updateBubbleControlPoint } from '../../actions/CurrentSlideActions';
import saveManager from './SaveManager';
import hoverManager from './HoverManager';
import toolTipManager from './ToolTipManager';
import videoUtils from './VideoUtils';

const mindMapUtils = {
    selectedMindMap: undefined, // uuid
    selectedNode: undefined, // controlPoint, controlPoint1, controlPoint2, etc
    initialPositions: [],
    insertImageTarget: undefined, // uuid of the mindmap where the image will be inserted

    isMindMapMode() {
        if (this.selectedMindMap || this.insertImageTarget)
            return true;
        else
            return false;
    },
    reset(resetContext = false) {
        this.selectedMindMap = undefined;
        this.selectedNode = undefined;
        this.initialPositions = [];
        this.insertImageTarget = undefined;

        if (resetContext)
            storeManager.getStore().dispatch(changeContextMode(modeType.CONTEXT_NONE));
    },
    isMindMapType(shapeModel) {
        if (shapeModel.isMindMap || shapeModel.mindMapProperty)
            return true;
        else
            return false;
    },
    getCurrentShape(uuid) {
        const state = storeManager.getState();
        const shapes = state.currentSlide.model.content;
        let i;
        let target;

        for (i=0; i<shapes.length; i++) {
            if (shapes[i].uuid == uuid) {
                target = shapes[i];
                break;
            }
        }

        return target;
    },
    getCurrentMindMap(uuid) {
        return this.getCurrentShape(uuid);
    },
    openSearch() {
        var dispatch = storeManager.getStore().dispatch;

        dispatch(changeCartoonistTabIndex(0)); // Cartoons should be the first selected tab

        setTimeout(function() {
            dispatch(changeContextMode(modeType.SEARCH_CONTEXT));
        }.bind(this), 5);
    },
    openSearchForImageInsertion(target) {
        this.insertImageTarget = target;
        this.openSearch();
    },
    getControlPointPosition(mindMapUid, nodeId) {
        let mindMap = this.getCurrentMindMap(mindMapUid);
        let currentCx;
        let currentCy;

        switch (nodeId) {
            case 'controlPoint': {
                currentCx = mindMap.cx;
                currentCy = mindMap.cy;
                break;
            }
            case 'controlPoint1': {
                currentCx = mindMap.cx1;
                currentCy = mindMap.cy1;
                break;
            }
            case 'controlPoint2': {
                currentCx = mindMap.cx2;
                currentCy = mindMap.cy2;
                break;
            }
            case 'controlPoint3': {
                currentCx = mindMap.cx3;
                currentCy = mindMap.cy3;
                break;
            }
            case 'controlPoint4': {
                currentCx = mindMap.cx4;
                currentCy = mindMap.cy4;
                break;
            }
            case 'controlPoint5': {
                currentCx = mindMap.cx5;
                currentCy = mindMap.cy5;
                break;
            }
        }

        return {cx: currentCx, cy: currentCy};
    },
    insertTextNode() {
        let currentControlPoint = this.getControlPointPosition(this.selectedMindMap, this.selectedNode);

        let topLeftPoint = { x: currentControlPoint.cx - (properties.RICH_TEXT_WIDTH / 2), y: currentControlPoint.cy - (properties.RICH_TEXT_HEIGHT / 2) };
        let mindMapProperty = { parentMindMap: this.selectedMindMap, selectedNode: this.selectedNode };

        createShapes.createTextBox(storeManager.getStore().dispatch, topLeftPoint, true, mindMapProperty);

        this.reset(true);
    },
    insertMediaNode(item, isCharacter = false) {
        if (this.insertImageTarget) {
            this.preloadImage(this.insertImageTarget, item.href);
        } else {
            let dispatch = storeManager.getStore().dispatch;
            let currentControlPoint = this.getControlPointPosition(this.selectedMindMap, this.selectedNode);

            let topLeftPoint = {
                x: currentControlPoint.cx - (properties.MIND_MAP_NODE_SIZE / 2),
                y: currentControlPoint.cy - (properties.MIND_MAP_NODE_SIZE / 2)
            };
            let mindMapProperty = {parentMindMap: this.selectedMindMap, selectedNode: this.selectedNode};

            if (isCharacter)
                createShapes.createCharacter(dispatch, item, topLeftPoint, mindMapProperty);
            else
                createShapes.createImage(dispatch, item, topLeftPoint, mindMapProperty);
        }

        this.reset(true);

        hoverManager.hide();
        toolTipManager.hideToolTip();
    },
    preloadImage(imageTarget, href) {
        let imageObj = new Image();

        imageObj.onload = function (e) {
            let target = e.target;
            let aspectRatio = target.width / target.height;
            let dispatch = storeManager.getStore().dispatch;

            dispatch(insertImageNode(imageTarget, href, aspectRatio));
        };

        imageObj.src = videoUtils.checkCacheBreaker(href);
    },
    removeImage(targetUid) {
        storeManager.getStore().dispatch(insertImageNode(targetUid, '', 1));
    },
    updateInitialPositions() {
        this.initialPositions = [];

        const shapes = storeManager.getState().currentSlide.model.content;
        let i;
        let shape;

        for (i=1; i<shapes.length; i++) {
            shape = shapes[i];

            if (shape.isMindMap || shape.mindMapProperty)
                this.initialPositions[shape.uuid] = {x: shape.x, y: shape.y, width: shape.width, height: shape.height};
        }
    },
    updateShapePosition(shapeModel, offsetX, offsetY) {
        if (shapeModel.mindMapProperty) // it's a node shape of a mind map
            this.updateMindMapControlPointPosition(shapeModel, offsetX, offsetY);

        if (shapeModel.isMindMap) // it's a mindMap so we should update the position of all nodes
            this.updateMindMapNodesPosition(shapeModel, offsetX, offsetY);
    },
    updateMindMapControlPointPosition(shapeModel, offsetX, offsetY) {
        let dispatch = storeManager.getStore().dispatch;
        let centerX;
        let centerY;

        if (offsetX === undefined) {
            centerX = shapeModel.x + shapeModel.width / 2;
            centerY = shapeModel.y + shapeModel.height / 2;
        } else {
            let initialPosition = this.initialPositions[shapeModel.uuid];
            let newX = initialPosition.x + offsetX;
            let newY = initialPosition.y + offsetY;

            centerX = newX + initialPosition.width / 2;
            centerY = newY + initialPosition.height / 2;
        }

        dispatch(updateBubbleControlPoint(shapeModel.mindMapProperty.parentMindMap, centerX, centerY, shapeModel.mindMapProperty.selectedNode));
    },
    updateMindMapNodesPosition(mindMapShapeModel, offsetX, offsetY) {
        const shapes = storeManager.getState().currentSlide.model.content;
        let dispatch = storeManager.getStore().dispatch;
        let i;
        let shape;
        let positions = [];
        let isEmpty = true;

        for (i=1; i<shapes.length; i++) {
            shape = shapes[i];

            if (shape.mindMapProperty && shape.mindMapProperty.parentMindMap === mindMapShapeModel.uuid) { // it's a node of the current mindMap
                if (offsetX === undefined) {
                    let currentControlPoint = this.getControlPointPosition(shape.mindMapProperty.parentMindMap, shape.mindMapProperty.selectedNode);

                    if (currentControlPoint) {
                        positions[shape.uuid] = {x: currentControlPoint.cx - shape.width / 2, y: currentControlPoint.cy - shape.height / 2};
                        isEmpty = false;
                    }
                } else {
                    let position = this.initialPositions[shape.uuid];

                    if (position) {
                        positions[shape.uuid] = {x: position.x + offsetX, y: position.y + offsetY};
                        isEmpty = false;
                    }
                }
            }
        }

        if (isEmpty == false) {
            dispatch(changeShapesPosition(positions));
            saveManager.isContentChanged(true);
        }
    },
    moveShapeByKeyboard(shapeModel, offsetX, offsetY) {
        this.updateInitialPositions();
        this.updateShapePosition(shapeModel, offsetX, offsetY);
    },
    updateShapePositionWhenResize(shapeModel) {
        setTimeout(function() {
            this.updateShapePosition(this.getCurrentShape(shapeModel.uuid));
        }.bind(this), 3);
    }
};

export default mindMapUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/MindMapUtils.js
 **/